import type { ComboboxOption } from "../components/form-fields/MultiCombobox";

export interface ComboboxOptionGroup {
  heading?: string;
  options: ComboboxOption[];
}

export function groupComboboxOptionList(
  optionList: ComboboxOption[],
): ComboboxOptionGroup[] {
  const groupList: ComboboxOptionGroup[] = [];
  const groupByHeading = new Map<string | undefined, ComboboxOptionGroup>();

  optionList.forEach((option) => {
    let group = groupByHeading.get(option.group);
    if (!group) {
      group = { heading: option.group, options: [] };
      groupByHeading.set(option.group, group);
      groupList.push(group);
    }
    group.options.push(option);
  });

  return groupList;
}
